export enum Locales {
  RU = 'ru',
  UA = 'ua',
}

export const LOCALES = [
  { value: Locales.UA, caption: 'Українська' },
  { value: Locales.RU, caption: 'Русский' },
]